import { render, staticRenderFns } from "./flag.vue?vue&type=template&id=7025f8ef&scoped=true&"
import script from "./flag.vue?vue&type=script&lang=ts&"
export * from "./flag.vue?vue&type=script&lang=ts&"
import style0 from "./flag.vue?vue&type=style&index=0&id=7025f8ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7025f8ef",
  null
  
)

export default component.exports